import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientContactInputView のスタイル
 */
export const hotlineClientContactInputViewStyle = tv({
    slots: {
        commentText: ['!text-base'],
        contentWrap: ['flex flex-col gap-32', 'pt-28 pb-32 px-16 lg:p-32'],
        scheduleField: ['flex-grow', 'w-full max-w-[320px]'],
        scheduleFieldText: [
            textStyle({ color: 'base', size: 'sm' }),
            'flex-shrink-0',
            'translate-y-[12px]',
        ],
        scheduleFieldWrap: ['flex flex-nowrap items-start gap-8'],
        scheduleFieldsWrap: ['flex flex-col gap-20'],
        skeletonFieldWrap: [],
    },
    variants: {
        isSkeleton: {
            true: {
                skeletonFieldWrap: ['flex flex-col gap-8'],
            },
        },
    },
});
